import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { Success } from '@wix/da-ds/pkg/Icons/Confirmations/Success';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';

import s from './OriginalsAcceptSuccessModal.scss';

interface Props {
  requestingUser: PapiUser;
  onRequestClose: () => void;
}

const OriginalsAcceptSuccessModal: React.FC<Props> = ({
  requestingUser,
  onRequestClose,
}) => {
  const { t } = useTranslation();
  return (
    <MessageModal
      isOpen
      className={s['root']}
      variant="horizontal"
      image={<Success />}
      title={t('studio.modals.originalsAcceptSuccess.title')}
      message={t('studio.modals.originalsAcceptSuccess.message')}
      footerButtons={[
        <TextButton
          key="sendMessage"
          size="medium"
          variant="main"
          href={Url.userMessageLink(requestingUser.username)}
        >
          {t('common.sendMessage')}
        </TextButton>,
        <BrandedButton
          key="gotIt"
          size="medium"
          variant="brand-green"
          onClick={() => {
            onRequestClose();
            window.location.reload();
          }}
        >
          {t('common.gotIt')}
        </BrandedButton>,
      ]}
    />
  );
};
OriginalsAcceptSuccessModal.displayName = 'OriginalsAcceptSuccessModal';

export default OriginalsAcceptSuccessModal;
